import {State} from '@/store/store'
import { ICaregiver } from '../caregiver/states'
import { ICenter } from '../center/states'
import { IPermission, IRole } from '../role/states'
import {IUser} from '../user/states'
import { ISchedule } from '../schedule/states'

export type UserProfile = IUser & {
  role: IRole,
  schedule?: ISchedule,
  permissions: IUserPermission[],
  center?: ICenter,
  caregiver?: ICaregiver,
}

export interface IUserPermission {
  key: string,
  level: string,
  type: string[]
}

export interface IUserLine {
  displayName: string
  pictureUrl: string
  statusMessage: string
  userId: string
  token: string
}

export class UserProfileState {
  public profile: UserProfile | {}
  public line?: IUserLine

  constructor() {
    this.profile = {
      metadata: {},
    }
  }
}

export default UserProfileState
